import {RunInAction, StoreAction} from "web-vcore";
import {Assert, NN} from "js-vextensions";
import {AutoRun_HandleBail, GetAsync} from "mobx-graphlink";
import {Me} from "../../Server/DB/users.js";
import {store} from "../../Store/index.js";
import {GetMapState} from "../../Store/main/maps/$mapState.js";
import {GetMap} from "../../Server/DB/maps.js";
import {MapState, PropertiesPanelState} from "../../Store/main/maps/@MapState.js";
import {ObservableSet} from "mobx";
import {Vec3} from "../ThreeJS/VectorStructs.js";

//let lastMapID: string|n;
AutoRun_HandleBail(()=>{
	Me(); // watch for user-login-data changes

	const mapID = store.main.maps.selectedMapID;
	if (mapID) {
		StartInitForNewlyLoadedMap(mapID);
	}
}, {name: "InitForNewlyLoadedMap"});

export const mapStatesInitialized = new ObservableSet<string>();

/** Returns true if the map state was successfully initialized. */
async function StartInitForNewlyLoadedMap(mapID: string) {
	Assert(mapID != null, "mapID cannot be null.");
	let mapState = GetMapState(mapID);
	//if (mapState?.initDone) return true; // 2nd-check for version-clearing
	if (mapStatesInitialized.has(mapID)) return true; // already initialized

	const map = await GetAsync(()=>GetMap(mapID));
	if (map == null) return false; // map must be private/deleted

	RunInAction("StartInitForNewlyLoadedMap_part1", ()=>{
		const rawDataFromStore = store.main.maps.mapStates.get(mapID);
		const restoredMapState = rawDataFromStore ?? new MapState();

		// commented; old approach; it would causes, eg. mapState.settings to not be connected with its class, breaking eg. its mobx-sync annotations!
		// (NEW: Fixed by adding proper handling of maps-that-contain-class-values, using the @format decorator + a call to parseStore; see Store/main/maps.ts)
		// always start with a fresh creation of map-state, so default-values get applied
		//const restoredMapState = Object.assign(new MapState(), rawDataFromStore);
		/*const restoredMapState = rawDataFromStore ?? new MapState();
		// for each mobx-observable sub-object, recreate it (else it won't be mobx-observable)
		restoredMapState.propertiesPanel = Object.assign(new PropertiesPanelState(), rawDataFromStore?.propertiesPanel);
		// for each class-sensitive sub-object, assign class
		Object.setPrototypeOf(restoredMapState.camPos, Vec3.prototype);
		Object.setPrototypeOf(restoredMapState.cursorPos, Vec3.prototype);*/

		// restore some non-saved props that are based on saved props
		// commented; moved to format-decorator on MapState class
		/*restoredMapState.camPos_unthrottled = restoredMapState.camPos;
		restoredMapState.camZoom_unthrottled = restoredMapState.camZoom;*/

		store.main.maps.mapStates.set(mapID, restoredMapState);
		mapStatesInitialized.add(mapID);
		mapState = restoredMapState;
	});

	// will probably need other init stuff here later

	return true;
}